import { config } from './config';

/**
 * Settings the container can override at start-up, so one image can be pointed at a different
 * backend. The values are served as /config.json (see docker/10-runtime-config.sh); when the file
 * is missing or empty, the app keeps the values compiled in from the environment file.
 */
export interface RuntimeConfig {
  apiUrl?: string;
}

const withTrailingSlash = (url: string): string => (url.endsWith('/') ? url : `${url}/`);

/** Reads /config.json and applies it. Never throws: without it the compiled defaults are used. */
export async function loadRuntimeConfig(): Promise<void> {
  try {
    const response = await fetch('config.json', { cache: 'no-store' });
    if (!response.ok) {
      return;
    }

    const runtimeConfig = (await response.json()) as RuntimeConfig;
    if (runtimeConfig?.apiUrl) {
      config.apiUrl = withTrailingSlash(runtimeConfig.apiUrl);
    }
  } catch {
    // No runtime configuration (for example `ng serve`), keep the compiled environment.
  }
}
